import { IconButton, Stack } from "@mui/material"
import { If } from "lib/@components/switch"
import { StandardBreadcrumbs } from "lib/@components/standardBreadcrumbs"
import Iconify from "minimals-template/components/Iconify"
import { BreadcrumbCrumb } from "./breadcrumb-crumb"

export function LibraryBreadcrumbs({ breadcrumbs, canDelete = false, onDelete }) {
    const breadcrumbItems = buildBreadcrumbItems(breadcrumbs)

    return (
        <Stack direction="row" alignItems="center" spacing={1}>
            <StandardBreadcrumbs sx={{ m: 0 }}>{breadcrumbItems}</StandardBreadcrumbs>
            <If value={canDelete}>
                <IconButton aria-label="Delete" size="small" color="error" onClick={onDelete}>
                    <Iconify icon="eva:trash-2-outline" />
                </IconButton>
            </If>
        </Stack>
    )
}

function buildBreadcrumbItems(breadcrumbs) {
    const items = []
    for (let index = 0; index < breadcrumbs.length; index += 1) {
        const breadcrumb = breadcrumbs[index]
        items.push(<BreadcrumbCrumb key={breadcrumb.id} item={breadcrumb} index={index} />)
    }
    return items
}
